import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCrossed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShieldCrossed"><Path d="M14.4758 13.9995L11.9882 11.5002M11.9882 11.5002L9.5 9.0003M11.9882 11.5002L14.4758 9.00052M11.9882 11.5002L9.5 14.0003M12 2.5L20.5 5.25V11.9123C20.5 16.8848 16 19.5 12 21.6579C8 19.5 3.5 16.8848 3.5 11.9123V5.25L12 2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShieldCrossed;
